'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cameraSnRegex = undefined;
exports.isKunaDevice = isKunaDevice;
exports.getRecordingReasonUrl = getRecordingReasonUrl;
exports.getThumbnailUrl = getThumbnailUrl;
exports.getSightImageThumbUrl = getSightImageThumbUrl;
exports.getModelFromSN = getModelFromSN;
exports.getAllUserForms = getAllUserForms;
exports.isDateInFuture = isDateInFuture;
exports.getTrialInfo = getTrialInfo;
exports.getUserNotificationSetting = getUserNotificationSetting;
exports.getSightMode = getSightMode;
exports.arrayBufferToBase64 = arrayBufferToBase64;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cameraSnRegex = exports.cameraSnRegex = /(OOKN|LTC)[\d\w]{10,30}/g;

function isKunaDevice(sn) {
  return sn.match(/^(OOK|LTC|KNP|V1)/i) !== null;
}

function getRecordingReasonUrl(sn, label) {
  return '/api/django/cameras/' + sn + '/recordings/' + label + '/reason/';
}

function getThumbnailUrl(sn, label) {
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;

  return '/api/django/cameras/' + sn + '/recordings/' + label + '/thumbnails/' + index + '/';
}

function getSightImageThumbUrl(sn, label) {
  return '/api/django/cameras/' + sn + '/sight_images/' + label + '/thumbnail';
}

function getModelFromSN(sn) {
  var model = 'KUNA_KNP01'; // Default is Kuna version
  if (!sn) {
    return null;
  }
  if (sn.match(/^OOKN/)) {
    model = 'KUNA_KNP01';
  } else if (sn.match(/^LTC/)) {
    model = 'KUNA_LTC01';
  } else if (sn.match(/^KNP04/)) {
    model = 'KUNA_KNP04';
  } else if (sn.match(/^KNP05/)) {
    model = 'KUNA_KNP05';
  } else if (sn.match(/^KNP06/)) {
    model = 'KUNA_KNP06';
  } else if (sn.match(/^V1/)) {
    model = 'KUNA_V1';
  }
  return model;
}

function getAllUserForms(name, email, snArray, zdID, portalUser, ticketAgentEmail) {
  var serialNumbers = snArray ? snArray.join(', ') : '';

  var returnUrl = 'https://docs.google.com/a/kunasystems.com/forms/d/e/1FAIpQLSewW8yZX97jkzIwbXrfqKyEk-GVW-_YdBZN_hoAPcALC001LA/viewform?' + ('entry.1100692629=' + name + '&') + ('entry.399854418=' + email + '&') + 'entry.187412787&' + ('entry.139574399=' + (zdID || '') + '&') + 'entry.1819753828=1&' + 'entry.1551688242&' + 'entry.1959016066';

  var RMAUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSdGJTmwf9RvQMenuVlOeCbrEU3xtOzeiCGG9gdGGPiKCx8PIQ/viewform?usp=pp_url&' + ('entry.62573712=' + name + '&') + ('entry.77816396=' + email + '&') + ('entry.1119535183=' + serialNumbers + '&') + ( // Serial Number
  'entry.1448798907=' + (zdID || '') + '&') + 'entry.423193711&' + 'entry.1654735149&' + 'entry.853470505&' + 'entry.486934236&' + 'entry.1449579439&' + 'entry.1327878756&' + 'entry.1733391185&' + 'entry.1452276992&' + 'entry.1499911625&' + 'entry.1866509203&' + 'entry.797756192&' + 'entry.52298907&' + 'entry.851050852&' + 'entry.1884997005&' + 'entry.1110526763&' + 'entry.1301892079&' + 'entry.23149441&' + 'entry.197811128';
  // const planMapping = {

  // }

  var stripeRefund = 'https://docs.google.com/forms/d/e/1FAIpQLSe7slp2U-nG3sBZ1yVXynQvrqfWGCnaxvEwZnXPOADJAc13qQ/viewform?usp=pp_url&' + ('entry.1238312633=' + (name || '') + '&') + ('entry.1230818858=' + email + '&') + ('entry.1018754303=' + serialNumbers + '&') + ('entry.1653632799=' + (zdID || '') + '&') + 'entry.1795504430';

  var stripeCredits = 'https://docs.google.com/forms/d/e/1FAIpQLSeiNQ8930MeakHD5zj5J7K5NbG5DgxSlO6Vob_hWGlDNwijmQ/viewform?usp=pp_url&' + ('entry.429303230=' + (name || '') + '&') + ('entry.1039262748=' + email + '&') + 'entry.36388794&' + ('entry.1900821905=' + (zdID || '') + '&') + 'entry.102502040&' + // This is subscription
  'entry.672497603&' + // Reason code
  'entry.295368599';

  // const cameraName = '';
  // const summary = '';
  var phoneSupport = 'https://docs.google.com/forms/d/e/1FAIpQLSf5BVlGsDHQl9wFhE5EyZh-aMdFhFqoS7qOWNx2uGk1ZQ75bA/viewform';

  var phoneSupportSetup = 'https://getkuna.typeform.com/to/sAgM0j?' + ('email=' + portalUser + '&') + ('user_email=' + email);

  var qualityAudit = 'https://docs.google.com/forms/d/e/1FAIpQLSchPAxqiVKuoiTS-7UxHW6Y3DRmC1_pXaV9njgBdJ8zuUcHsQ/viewform?usp=pp_url' + ('&entry.1481102484=' + (zdID || '')) + ('&entry.246288835=' + (ticketAgentEmail || '')) + ( // Agent under review
  '&entry.1013038510=' + portalUser) + '&entry.762808321' + '&entry.1805143268' + '&entry.134615964' + '&entry.1914889513' + '&entry.1957552019';

  return {
    returnUrl: returnUrl,
    RMAUrl: RMAUrl,
    stripeRefund: stripeRefund,
    stripeCredits: stripeCredits,
    phoneSupport: phoneSupport,
    phoneSupportSetup: phoneSupportSetup,
    qualityAudit: qualityAudit
  };
}

function isDateInFuture(date) {
  return !!(date && (0, _moment2.default)(date) - (0, _moment2.default)() > 0);
}

function getTrialInfo(loadedCustomers, ownerEmail) {
  var subscription = loadedCustomers[ownerEmail.toLowerCase()].subscription;

  var trial = subscription.loaded ? subscription.result.profile.trial_end : undefined;

  var onCouponTrial = subscription.loaded && subscription.result.on_coupon_trial;

  var onTrial = isDateInFuture(trial);

  return { trial: trial, onTrial: onTrial, onCouponTrial: onCouponTrial };
}

function getUserNotificationSetting(loadedCustomers, ownerEmail) {
  var subscription = loadedCustomers[ownerEmail.toLowerCase()].subscription;
  // Get the profile object first

  var profile = subscription.loaded && subscription.result.profile;
  var notificationsEnabled = true;
  if (!profile) {
    return { notificationsEnabled: notificationsEnabled };
  }
  notificationsEnabled = profile.notifications_enabled;
  var notificationsEnableAt = profile.notifications_enable_at;
  var notificationsEnableRelative = null;
  if (!notificationsEnabled && (0, _moment2.default)(notificationsEnableAt) - (0, _moment2.default)() < 0) {
    notificationsEnableAt = null;
    // Turns out that if the notificationEnableAt time is in the past and not reset
    // then it actually means that notifications are enabled
    notificationsEnabled = true;
  }
  if (notificationsEnableAt) {
    notificationsEnableRelative = (0, _moment2.default)(notificationsEnableAt).fromNow();
  }
  return {
    notificationsEnabled: notificationsEnabled,
    notificationsEnableAt: notificationsEnableAt,
    notificationsEnableRelative: notificationsEnableRelative
  };
}

function getSightMode(sightModeEnum) {
  switch (sightModeEnum) {
    case 0:
      return 'People only';
    case 1:
      return 'Vehicles only';
    case 2:
      return 'People & vehicles';
    case 3:
      return 'Never notify';
    default:
      return 'ERROR: unknown sight mode!';
  }
}

function arrayBufferToBase64(buffer) {
  var binary = '';
  var bytes = [].slice.call(new Uint8Array(buffer));

  // eslint-disable-next-line
  bytes.forEach(function (b) {
    return binary += String.fromCharCode(b);
  });

  return window.btoa(binary);
}

// Currently this function lives in CameraWrapper instead
// I think that that is the correct home for it. But perhaps
// constants should be moved out somewhere else? Unsure.
/*
export function getCameraDetails(incomingProps) {
  const {camera, email, name, zdTicketUrl, firmware} = incomingProps;

  // onPlan, timezone,
  const shared = camera.owner.email !== email;
  const slackDeleteURI = 'slack://channel?team=T03NPMBJG&id=C1W8D9VJA';
  const RMAUrl = rmaFormLink(name, email, camera, zdTicketUrl, true);
  const returnUrl = rmaFormLink(name, email, camera, zdTicketUrl, false);
  const djangoUrl = `https://master.kunasystems.com/admin/camera/camera/${camera.id}/`;
  const logglyUrl = `https://kuna.loggly.com/search#terms=tag%3A%22${camera.serial_number}%22`;
  const deleteUrl = `${djangoUrl}delete/`;
  const deleteText = `Can someone please delete ${camera.serial_number} from requester ${email} ${shared ? `with owner ${camera.owner.email} ` : ''}\n${deleteUrl}\nReason: <Insert>`;

  const firmwareModel = getModelFromSN(camera.serial_number);

  const upToDateFW = firmware && parseInt(firmware[firmwareModel].version, 10);
  const isFwUpToDate = upToDateFW === camera.build;
  const isBetaFW = upToDateFW > camera.build;
  console.log(`In cameraWrapper render${firmware[firmwareModel].loaded}`);

  const cameraProps = {
    shared,
    slackDeleteURI,
    RMAUrl,
    returnUrl,
    djangoUrl,
    logglyUrl,
    deleteUrl,
    deleteText,
    firmwareModel,
    upToDateFW,
    isFwUpToDate,
    isBetaFW,
    ...incomingProps,
  };
  return cameraProps;
}
*/


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/kunaUtils.js
 ** module id = 100
 ** module chunks = 0
 **/